import {getDatadogRum} from '../../../util/datadog/datadogRum';
import {QueryVars} from '../bucketedData/queries/queryVars';

export type LinePlotDatadogAlerts =
  | 'vis-team-alert-zero-length-histories'
  | 'vis-team-alert-history-line-ratio'
  | 'vis-team-alert-no-lines';

const DD_RUM = getDatadogRum();

export const fireLinePlotAlert = (
  name: LinePlotDatadogAlerts,
  context: Record<string, any>
) => {
  DD_RUM.addAction(name, context);
};

export const detectLineAnomalies = ({
  numLines,
  numHistories,
  isSystemMetric,
}: {
  numLines: number;
  numHistories: number;
  isSystemMetric: boolean;
}) => {
  // we don't want to log anything when there's no history data to build lines from
  if (numHistories > 0) {
    // Rationale: if the number of lines constructed from the number of histories changes, that might indicate a bug in the line construction logic
    fireLinePlotAlert('vis-team-alert-history-line-ratio', {
      numberOfLines: numLines,
      numberOfHistories: numHistories,
      lineRatio: numLines / numHistories,
      isSystemMetric,
    });

    // Rationale: if no lines are constructed from a non-zero number of valid histories this is almost guaranteed to be a bug
    if (numLines === 0) {
      fireLinePlotAlert('vis-team-alert-no-lines', {
        numberOfLines: numLines,
        numberOfHistories: numHistories,
        isSystemMetric,
      });
    }
  }
};
/**
 * Log any zero length histories that are returned. Increases in zero length histories may indicate a malformed query in the frontend or it may indicate issues with the backend.
 */
export const detectZeroLengthHistories = ({
  histories,
  id,
  displayName,
  specs,
}: {
  histories: any[];
  id: string;
  displayName: string;
  specs: QueryVars['bucketedHistorySpecs'];
}) => {
  try {
    const zeroLengthHistories = histories?.reduce(
      (acc, history) => {
        if (history.length === 0) {
          acc.zeroHistoryCount++;
        } else {
          acc.historyCount++;
        }
        return acc;
      },
      {
        historyCount: 0,
        zeroHistoryCount: 0,
      }
    );
    // we only want to fire the alert if there are zero length histories and the history count is greater than 0
    if (
      zeroLengthHistories.zeroHistoryCount > 0 &&
      zeroLengthHistories.historyCount > 0
    ) {
      console.warn(
        'Zero length histories returned from the backend. Count: ',
        zeroLengthHistories
      );
      fireLinePlotAlert('vis-team-alert-zero-length-histories', {
        historyCount: zeroLengthHistories.historyCount,
        isGrouped: false,
        runDisplayName: displayName,
        runId: id,
        specs,
        zeroHistoryCount: zeroLengthHistories.zeroHistoryCount,
      });
    }
  } catch (e) {
    console.error('Error counting zero length histories');
  }
};
